import "./column-components.b2a20dc1.js";
import "./column-components.e7f1a130.js";
import {Component as $c0oXD$Component, createContext as $c0oXD$createContext, useRef as $c0oXD$useRef, useContext as $c0oXD$useContext, createElement as $c0oXD$createElement} from "react";
import $c0oXD$macrostrathyper from "@macrostrat/hyper";
import {path as $c0oXD$path} from "d3-path";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;




var $aVUB5 = parcelRequire("aVUB5");

var $fwzVu = parcelRequire("fwzVu");
let $fe5bf96defe66407$var$sequence = 0; // Initialize a sequence counter
function $fe5bf96defe66407$var$getUniqueIdentifier() {
    // Generate a unique identifier using a sequential method that is stable across repeated
    // re-renders. This evolves from a UUID-based approach for SSR (server-side rendering) compatibility.
    const id = `uuid-${$fe5bf96defe66407$var$sequence}`;
    $fe5bf96defe66407$var$sequence += 1; // Increment the sequence for the next call
    return id;
}
class $fe5bf96defe66407$export$748c8bb116429550 extends (0, $c0oXD$Component) {
    constructor(props){
        super(props);
        this.UUID = $fe5bf96defe66407$var$getUniqueIdentifier();
    }
}
const $fe5bf96defe66407$var$UUIDContext = (0, $c0oXD$createContext)(null);
function $fe5bf96defe66407$var$useBasicUUID() {
    const ref = (0, $c0oXD$useRef)($fe5bf96defe66407$var$getUniqueIdentifier());
    return ref.current;
}
const $fe5bf96defe66407$export$b53193151b894db6 = function() {
    const uuid = (0, $c0oXD$useContext)($fe5bf96defe66407$var$UUIDContext);
    if (uuid == null) return $fe5bf96defe66407$var$useBasicUUID();
    return uuid;
};
function $fe5bf96defe66407$export$1d23684b3f3271ac({ children: children }) {
    const ref = (0, $c0oXD$useRef)($fe5bf96defe66407$var$getUniqueIdentifier());
    return (0, $c0oXD$macrostrathyper)($fe5bf96defe66407$var$UUIDContext.Provider, {
        value: ref.current,
        children: children
    });
}
function $fe5bf96defe66407$export$5e9808bef3bd64be(props) {
    const { pixelHeight: height, width: width } = (0, $c0oXD$useContext)((0, $aVUB5.ColumnLayoutContext));
    let { id: frameID, className: className } = props;
    if (frameID.startsWith("#")) frameID = frameID.slice(1);
    return (0, $c0oXD$macrostrathyper)("rect", {
        id: frameID,
        x: 0,
        y: 0,
        width: width,
        height: height,
        className: className
    });
}
function $fe5bf96defe66407$export$686c342f9382ceb9(props) {
    let { id: frameID, zigZagBottom: zigZagBottom = false, zigZagTop: zigZagTop = false } = props;
    const { scale: scale, divisions: divisions, grainsizeScale: gs } = (0, $aVUB5.useColumnLayout)();
    if (frameID.startsWith("#")) frameID = frameID.slice(1);
    if (divisions.length === 0) return null;
    const [bottomOfSection, topOfSection] = scale.domain();
    const topOf = function(d) {
        let { top: top } = d;
        if (top > topOfSection) top = topOfSection;
        return scale(top);
    };
    const bottomOf = function(d) {
        let { bottom: bottom } = d;
        if (bottom < bottomOfSection) bottom = bottomOfSection;
        return scale(bottom);
    };
    const filteredDivisions = Array.from(divisions).filter(function(d) {
        if (d.top <= bottomOfSection) return false;
        if (d.bottom > topOfSection) return false;
        return true;
    });
    let d = (0, $c0oXD$path)();
    let currentGrainsize = "m";
    let i = 0;
    for (const div of filteredDivisions){
        if (i === 0) {
            // First division
            // start the path at the bottom
            const y = bottomOf(div);
            d.moveTo(0, y);
        }
        if (div.grainsize != null) currentGrainsize = div.grainsize;
        const x1 = gs(currentGrainsize);
        if (i === 0 && zigZagBottom) // Draw zig-zag at bottom
        (0, $fwzVu.drawZigZagAtConstantHeight)(d, 0, x1, bottomOf(div));
        else // Draw a normal line
        d.lineTo(x1, bottomOf(div));
        d.lineTo(x1, bottomOf(div));
        d.lineTo(x1, topOf(div));
        if (i === filteredDivisions.length - 1) {
            // Last division
            // Draw top
            if (zigZagTop) (0, $fwzVu.drawZigZagAtConstantHeight)(d, x1, 0, topOf(div));
            else d.lineTo(0, topOf(div));
        }
        i++;
    }
    d.closePath();
    return (0, $c0oXD$macrostrathyper)("path", {
        id: frameID,
        key: frameID,
        d: d.toString()
    });
}
const $fe5bf96defe66407$export$407988c5e190497b = function(props) {
    let { id: id, children: children, ...rest } = props;
    if (id.startsWith("#")) id = id.slice(1);
    return (0, $c0oXD$createElement)("clipPath", {
        id: id,
        key: id,
        ...rest
    }, children);
};
const $fe5bf96defe66407$var$UseFrame = function(props) {
    const { id: frameID, ...rest } = props;
    return (0, $c0oXD$macrostrathyper)("use.frame", {
        xlinkHref: frameID,
        fill: "transparent",
        key: "frame",
        ...rest
    });
};
const $fe5bf96defe66407$var$prefixID = function(uuid, prefixes) {
    const res = {};
    for (let prefix of Array.from(prefixes))res[prefix + "ID"] = `#${uuid}-${prefix}`;
    return res;
};
function $fe5bf96defe66407$export$708d3f2ecf132c6c(props) {
    const { left: left = 0, shiftY: shiftY = 0, className: className, onClick: onClick, children: children, frame: frame = $fe5bf96defe66407$export$5e9808bef3bd64be, clip: clip = true } = props;
    const uuid = $fe5bf96defe66407$export$b53193151b894db6();
    const { frameID: frameID, clipID: clipID } = $fe5bf96defe66407$var$prefixID(uuid, [
        "frame",
        "clip"
    ]);
    let transform = null;
    if (left != null) transform = `translate(${left} ${shiftY})`;
    const frameClassName = "clip-frame column-clip-frame";
    let _frame = (0, $c0oXD$macrostrathyper)(frame, {
        id: frameID,
        className: frameClassName
    });
    let defs = null;
    let clipPath = null;
    if (clip) {
        defs = (0, $c0oXD$macrostrathyper)("defs", {
            key: "defs"
        }, [
            _frame,
            (0, $c0oXD$macrostrathyper)($fe5bf96defe66407$export$407988c5e190497b, {
                id: clipID
            }, (0, $c0oXD$macrostrathyper)($fe5bf96defe66407$var$UseFrame, {
                id: frameID
            }))
        ]);
        clipPath = `url(${clipID})`;
        _frame = (0, $c0oXD$macrostrathyper)($fe5bf96defe66407$var$UseFrame, {
            id: frameID,
            className: frameClassName
        });
    }
    return (0, $c0oXD$macrostrathyper)("g", {
        className: className,
        transform: transform,
        onClick: onClick
    }, [
        defs,
        (0, $c0oXD$macrostrathyper)("g.inner", {
            clipPath: clipPath
        }, children),
        // Frame must go last
        _frame
    ]);
}


export {$fe5bf96defe66407$export$748c8bb116429550 as UUIDComponent, $fe5bf96defe66407$export$b53193151b894db6 as useUUID, $fe5bf96defe66407$export$1d23684b3f3271ac as UUIDProvider, $fe5bf96defe66407$export$5e9808bef3bd64be as SimpleFrame, $fe5bf96defe66407$export$686c342f9382ceb9 as GrainsizeFrame, $fe5bf96defe66407$export$407988c5e190497b as ClipPath, $fe5bf96defe66407$export$708d3f2ecf132c6c as ClippingFrame};
//# sourceMappingURL=column-components.218afc30.js.map
